import React, { Component } from "react";
import { observer } from "mobx-react";
import Core from "../../Core";

export default observer(
	class LicenseListRow extends Component {
		onEditClicked() {
			const { license } = this.props;
			const hash = `#license-detail?id=${license.Id}`;
			window.location.hash = hash;
		}

		onDeleteClicked() {
			var result = window.confirm("Delete record?");
			if (result) {
				const { license } = this.props;
				license.store.deleteById(license.Id);
			}
		}

		onViewLicensesInUseClicked() {
			const { license, stores } = this.props;
			if (license) {
				let customer = stores.data.CustomersStore.findById(license.CustomerId);
				if (customer) {
					const hash = `#licenses-in-use-list?customerId=${customer.Id}&licenseId=${license.Id}`;
					window.location.hash = hash;
				}
			}
		}

		render() {
			const { license, stores } = this.props;

			let applicationName = "";
			const application = stores.data.ApplicationsStore.findById(license.ApplicationId);
			if (application) applicationName = application.Name;

			let licenseTypeName = "";
			const licenseType = stores.data.Enums.LicenseTypes.findByKey(license.TypeId);
			if (licenseType) licenseTypeName = licenseType.Name;

			let endDate = "";
			if (license.EndDate) {
				endDate = license.EndDate.format("L");
			}

			// Admin buttons
			let editButton = null;
			let deleteButton = null;
			if (stores.currentUser.user.isAdmin) {
				editButton = <Core.Components.Buttons.Edit onClick={this.onEditClicked.bind(this)} />;
				deleteButton = <Core.Components.Buttons.Delete onClick={this.onDeleteClicked.bind(this)} />;
			}

			// LicensesInUse
			let licensesInUseList = stores.data.LicensesInUseStore.findByLicenseId(license.Id);
			const licensesInUseCount = licensesInUseList.length;

			// Internal remark
			let internalRemarkColumn = null;
			if (stores.currentUser.user.isAdmin) {
				internalRemarkColumn = license.InternalRemark;
			}

			return (
				<tr>
					<td>{applicationName}</td>
					<td>{licenseTypeName}</td>
					<td>{license.Number}</td>
					<td>
						<Core.Components.Inputs.ButtonInputGroup
							placeholder={"0"}
							value={licensesInUseCount}
							readOnly={true}
							onClick={this.onViewLicensesInUseClicked.bind(this)}
							glyphicon={"search"}
							disabled={licensesInUseCount === 0}
						/>
					</td>
					<td>{endDate}</td>
					<td>{internalRemarkColumn}</td>
					<td>{editButton}</td>
					<td>{deleteButton}</td>
				</tr>
			);
		}
	}
);



// WEBPACK FOOTER //
// ./src/Components/LicensesList/LicenseListRow.js